const layoutNames = {
  inside: 'insideLayout',
  humble: 'humbleLayout',
  profile: 'profileLayout',
  userProfile: 'userProfileLayout',
  subscription: 'subscriptionLayout',
  withoutHeader: 'withoutHeaderLayout',
  profileContent: 'profileContentLayout',
  withBreadcrumbs: 'withBreadcrumbsLayout',
  profileSubscription: 'profileSubscriptionLayout',
}


export default layoutNames
